import { createSlice } from "@reduxjs/toolkit";

const initialState = { subscriptions: [], subscriptionDetails: null };

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setSubscriptionList: (state, { payload }) => {
      return {
        ...state,
        subscriptions: payload,
      };
    },
    deleteSubscription: (state, { payload }) => {
      return {
        ...state,
        subscriptions: state.subscriptions.filter((sub) => sub._id !== payload),
      };
    },
  },
});
